// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__QReit","option":"styles_option__1oCjL","focussed":"styles_focussed__tH2Us"};